// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1uhgY","question":"styles_question__x5dZU","description":"styles_description__3UrHZ"};